/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown>, price: NonNullable<unknown>, period: NonNullable<unknown> }} Confirmdowngradedescription2Inputs */

const en_confirmdowngradedescription2 = /** @type {(inputs: Confirmdowngradedescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are switching to the ${i?.tier} plan for ${i?.price} ${i?.period}. Your current plan runs until the end of the period you already paid for, then the new one takes over. Nothing is charged now.`)
};

const de_confirmdowngradedescription2 = /** @type {(inputs: Confirmdowngradedescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du wechselst zum ${i?.tier}-Plan für ${i?.price} ${i?.period}. Dein aktueller Plan läuft bis zum Ende der bereits bezahlten Periode weiter, danach greift der neue. Es wird jetzt nichts berechnet.`)
};

/**
* | output |
* | --- |
* | "You are switching to the {tier} plan for {price} {period}. Your current plan runs until the end of the period you already paid for, then the new one takes ov..." |
*
* @param {Confirmdowngradedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const confirmdowngradedescription2 = /** @type {((inputs: Confirmdowngradedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmdowngradedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirmdowngradedescription2(inputs)
	return de_confirmdowngradedescription2(inputs)
});
export { confirmdowngradedescription2 as "confirmDowngradeDescription" }